export const SISA_QUOTA_TRAYEK_URL = 'dashboard/sisa_kuota_trayek'
export const SISA_QUOTA_TRAYEK_ERROR = 'SISA_QUOTA_TRAYEK_ERROR'
export const SISA_QUOTA_TRAYEK_LOADING = 'SISA_QUOTA_TRAYEK_LOADING'
export const SISA_QUOTA_TRAYEK_SUCCESS = 'SISA_QUOTA_TRAYEK_SUCCESS'